import fastdom from 'fastdom';

/**
 * This component is intended to build a skeleton card or a set of skeleton cards and place it in a given container.
 */
export default class BlogArticleCardSkeleton {

  setContainer(containerQuerySelector) {
    this.container = containerQuerySelector
    ? document.querySelector(containerQuerySelector) : undefined;
  }


  setCardCounts(cardCount) {
    this.cardCount = cardCount > 20 ? cardCount : 20;
  }

  /**
   * create: creates a set of card skeletons and places them in a given container.
   */
  create() {
    fastdom.mutate(() => {
      if (this.container) {
        this.container.innerHTML = this.getCardSkeleton();
      }
    });
  }

  destroy() {
    fastdom.mutate(() => {
      if (this.container) {
        this.container.innerHTML = '';
      }
    });
  }

  /**
   * getCardSkeleton: builds and returns a string representing the skeleton cards to show.
   * @returns an string ready to create HTML nodes representing card grid skeletons.
   */
  getCardSkeleton() {
    const cardList = Array.from({ length: this.cardCount }, () => this.getCardHtml()).join('');
    return cardList;
  }

  /**
   * getCardHtml: builds and returns a string representing the template of a article card skeleton.
   * @returns a card skeleton string ready to be used to create a HTML node.
   */

  getCardHtml() {
    return (`
    <div ${this.skeletonCustomDataValue} class="nhs-c-card-skeleton nhs-c-card">
        <div class="nhs-c-card-skeleton__images">
        </div>
        <div class="nhs-c-card-skeleton__placeholder-item">
            <div class="nhs-c-card-skeleton__animated-background">
                <div class="nhs-c-card-skeleton__bg-mask nhs-c-card-skeleton__title-top"></div>
                <div class="nhs-c-card-skeleton__bg-mask nhs-c-card-skeleton__title-left"></div>
                <div class="nhs-c-card-skeleton__bg-mask nhs-c-card-skeleton__title-right"></div>
                <div class="nhs-c-card-skeleton__bg-mask nhs-c-card-skeleton__title-bottom"></div>
                <div class="nhs-c-card-skeleton__bg-mask nhs-c-card-skeleton__button-top"></div>
                <div class="nhs-c-card-skeleton__bg-mask nhs-c-card-skeleton__button-bottom"></div>
            </div>
        </div>
    </div>`);
  }
}
